var  app = angular.module('directives.feedback', []);

require('./directives/feedback.directive.js');
require('./stylesheets/styles.sass');
require('./stylesheets/callback.scss');

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/feedback/index.js
 ** module id = 162
 ** module chunks = 1
 **/